// only in Standalone application
import './scss/standalone.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import('./bootstrap');

export {};